import { projectDomainName } from 'shared/constants'

import { getPureGameId } from '../providersData/GameCatalog/uniqGameId'
import { DigitainSlotToken } from '../types/interfaces/Slots/DigitainSlot'
import { ISlotViewItem } from '../types/interfaces/Slots/Slots'

export const digitainGameLaunch = {
  stage: 'https://partnerapi-gli.stg-digi.com/GamesLaunch/Launch',
  prod: 'https://launchdigi.net/GamesLaunch/Launch',
}

type CreateDigitainUrlParams = {
  gameId: ISlotViewItem['gameId']
  token: DigitainSlotToken
  deviceType: '2' | '1' // 2-mob, 1-desk
  lang: string
  playMode?: 'real' | 'demo'
}

export const createDigitainUrl = (props: CreateDigitainUrlParams) => {
  const params = new URLSearchParams({
    ...props,
    gameId: getPureGameId(props.gameId),
    playMode: props.playMode ?? 'real',
    // ID'шник сайта-партнера
    operatorId: 'FF380002', // stage -> '9AC8BE58',
    // // URL (без https://) для редиректа на главную страницу
    mainDomain: projectDomainName,
    // // Сюда надо прокидывать ссылку на депозит
    cashierUrl: projectDomainName,
  })

  return `${digitainGameLaunch.prod}?${params.toString()}`
}
